__turbopack_context__.v({
  "agreement": "bonus-conversion-form-module-scss-module__oewLEG__agreement",
  "checkboxes": "bonus-conversion-form-module-scss-module__oewLEG__checkboxes",
  "error": "bonus-conversion-form-module-scss-module__oewLEG__error",
  "form": "bonus-conversion-form-module-scss-module__oewLEG__form",
  "formItem": "bonus-conversion-form-module-scss-module__oewLEG__formItem",
  "pending": "bonus-conversion-form-module-scss-module__oewLEG__pending",
  "preloader": "bonus-conversion-form-module-scss-module__oewLEG__preloader",
  "root": "bonus-conversion-form-module-scss-module__oewLEG__root",
  "submit": "bonus-conversion-form-module-scss-module__oewLEG__submit",
  "title": "bonus-conversion-form-module-scss-module__oewLEG__title",
});
